import Vue from 'vue'
import App from './App.vue';
import VueGtag from 'vue-gtag';
import vuetify from './plugins/vuetify';
import router from './router/alumnier.routes';
import AOS from 'aos';
import 'aos/dist/aos.css';

Vue.config.productionTip = false

const initValue = localStorage.analyticsEnabled;
let gaEnabled = false;
if ( initValue !== undefined) {
  gaEnabled = initValue === 'true';
} else {
  gaEnabled = true;
}

Vue.use(VueGtag, {
  config: {
    id: 'UA-156294509-2',
    enabled: gaEnabled
  },
  // workaround. try to run Object.keys(window).filter(e => e.indexOf('ga') > -1) and the ga-disable-UA-156294509-1 does not appear
  onReady(){
    if (!gaEnabled){
      Vue.$gtag.optOut();
    }
  },
}, router);

new Vue({
  created () {
    AOS.init()
  },
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
